<template>
	<step
		name="select-product"
		:title="title"
		valid>
		<template slot="title">
			<div class="grid">
				<div class="cell cell--fit">
					<template v-if="check.hasSelectedProduct">
						<h5
							class="configurator-step__title cursor-pointer"
							@click="setStepActive('select-product')">
							<strong>Product:</strong>
							{{ productName }}
						</h5>
					</template>
					<template v-else>
						<h5 class="configurator-step__title">{{ title }}</h5>
					</template>
				</div>
			</div>
		</template>

		<div
			class="configurator-options grid grid--gutters-s grid--1-4 grid--l-1-3 grid--ms-1-2">
			<product-option
				v-for="(product, index) in sortedProducts"
				:option="product"
				:key="index" />
		</div>
	</step>
</template>

<script>
import step from "@/components/step/step";
import productOption from "@/components/product/product-option";

export default {
	name: "Product",
	components: {
		step,
		productOption
	},
	computed: {
		sortedProducts () {
			const productFronts = this.productData;
			return productFronts.sort((a, b) => a.id - b.id);
		},
		selectedProduct () {
			return this.$store.getters.getSelectedProduct;
		},
		check () {
			return this.$store.getters.checkData;
		},
		title () {
			return this.$store.getters.uploadsAreComplete && !this.hasMultipleSpecificationMatches
				? "Product"
				: "Kies een product";
		},
		productData () {
			return this.$store.getters.getProductData;
		},
		productName () {
			if (this.selectedProduct === null) {
				return null;
			}

			return this.selectedProduct.name;
		}
	},
	methods: {
		stepExists (stepToCheck) {
			return this.$store.getters.getStepExists(stepToCheck);
		},
		setStepActive (step) {
			if (this.stepExists(step).bool) {
				this.$store.commit("SET_STEP_ACTIVE", step);
			}
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/product/product.vue